'use client';

import React, { useRef } from 'react';
import { useSmartLinks } from '../../hooks/useSmartLinks';

interface HeavenpediaContentWrapperProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Minimal client wrapper that adds smart link handling to content.
 * The content itself is rendered server-side; this just adds the
 * click handler for internal link navigation.
 */
const HeavenpediaContentWrapper: React.FC<HeavenpediaContentWrapperProps> = ({
  children,
  className = '',
  style,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  
  // Use smart links hook to handle internal link clicks
  useSmartLinks(contentRef);
  
  return (
    <div ref={contentRef} className={className} style={style}>
      {children}
    </div>
  );
};

export default HeavenpediaContentWrapper;

